import React from "react";
import { Client, ClientExtend } from "../../../types/clients.types";
import { useSingleClientExtend } from "../../../hooks/useClients";
import { dateConverter } from "../../../../../utils/dateConverter";
import { limitString } from "../../../../../utils/string.utils";
import useNavigationApp from "../../../../../navigation/useNavigationApp";
import PaygoListPresenter from "../../../../paygo/components/PaygoList/PaygoList/PaygoListPresenter";
import { Wallet } from "../../../../wallet/types/wallet.types";

export type ClientExtendInfoType = ClientExtend & { "paygolist": unknown, "walletList": unknown };

export interface ClientExtendInfoProps<T = unknown> {
  info: keyof ClientExtendInfoType ;
  userOrgaId?: string;
  styled?: boolean;
  emptyText?: string;
  limitText?: number;
  renderComponent?: (config: {
    labelRender: React.ReactNode;
    item?: T;

    goTo: () => void;
  }) => JSX.Element;
}

export function ClientExtendInfo({
    userOrgaId:id,
  emptyText,
  info,
  styled,
  limitText,
  renderComponent,
}: ClientExtendInfoProps) {
  const { singleClientQuery,    allWalletsQuery : walletsListQuery} = useSingleClientExtend(id);
  const navigation = useNavigationApp();



  if (info === "walletList" && renderComponent  ) {
    if (walletsListQuery.isLoading) return <>...</>;
    if (walletsListQuery.isError) return <>{emptyText || "-"}</>;
    return renderComponent({
      labelRender: walletsListQuery.data?.data?.map(wallet => wallet.wallet_name).join(", ") || "",
      item: walletsListQuery.data?.data as Wallet[] || [],
      goTo: () => {}
    }
    )
  }



  const convertValue = (info: keyof ClientExtendInfoType , value: any) => {
    switch (info) {
      case "client_created_at":
        return dateConverter(value);
      default:
        return value;
    }
  };





  if (renderComponent && singleClientQuery.data) {
    return renderComponent({
      labelRender: convertValue(info,singleClientQuery.data[info as keyof Client]),
      goTo: () => {navigation.goToSingleClient(singleClientQuery.data.client_id);},
    });}

  if (singleClientQuery.isLoading) return <>...</>;
  if (singleClientQuery.isError) return <>{emptyText || "-"}</>;

  if (info === "paygolist") {
    return <PaygoListPresenter preFilter={{paygo_client: `=${singleClientQuery.data?.client_id}`}}/>
  }
  return (
    <>
      {singleClientQuery.data &&
        limitString(
          convertValue(info, singleClientQuery.data[info as keyof Client]),
          limitText
        )}
    </>
  );
}
